<template>
  <div v-if="!pedidofinalizado && !carregamentoPedidos" class="fullbody">
    <div class="resumo-compra">
      <h1>Resumo do Pedido</h1>
      <hr />
      <div>
        <ul v-for="resumoCompra in resumoCompras" :key="resumoCompra.codigo">
          <div class="container">
            <div id="resumoItem" class="row">
              <div class="col-md">
                <strong>{{ resumoCompra.nomeproduto }}</strong>
                <hr />
                <div class="row">
                  <div class="col"><strong>Descrição:</strong></div>
                  <div class="col"><strong>Qtd:</strong></div>
                  <div class="col"><strong>R$(un):</strong></div>
                  <div class="col"><strong>Total:</strong></div>
                </div>
                <ul
                  v-for="variacao in resumoCompra.variacao"
                  :key="variacao.descricao_sku"
                  style="list-style: disc"
                >
                  <li>
                    <div class="row">
                      <div class="col">{{ variacao.descricao_sku }}</div>
                      <div class="col">
                        {{ variacao.quantidade }}
                      </div>
                      <div class="col">
                        R$
                        {{
                          variacao.preco.toLocaleString("pt-br", {
                            minimumFractionDigits: 2,
                          })
                        }}
                      </div>
                      <div class="col">
                        R$
                        {{
                          (variacao.quantidade * variacao.preco).toLocaleString(
                            "pt-br",
                            {
                              minimumFractionDigits: 2,
                            }
                          )
                        }}
                      </div>
                    </div>
                  </li>
                </ul>
                <br />
                <li><strong>Itens:</strong> {{ resumoCompra.qtd }}</li>
              </div>
              <div class="col-md-5" v-if="resumoCompra.variacao[0].url">
                <img
                  :src="resumoCompra.variacao[0].url"
                  style="width: 8rem"
                  alt=""
                />
              </div>
              <div class="col-md-5" v-else>
                <img :src="resumoCompra.url" style="width: 8rem" alt="" />
              </div>
            </div>
          </div>
        </ul>
        <div class="container">
          <div class="form-floating">
            <textarea
              class="form-control"
              placeholder="Faça uma observação aqui"
              id="floatingTextarea2"
              v-model.trim="observacao.val"
              style="height: 100px"
            ></textarea>
            <label id="observation" for="floatingTextarea2">Observações:</label>
          </div>
          <div class="mb-3 col-md-6 mx-auto">
            <label for="filial" class="form-label">Filial:</label>
            <select
              name="filial"
              id="filial"
              class="form-select"
              v-model="filial.val"
            >
              <option disabled value="">Selecione uma filial</option>
              <option
                v-for="(f, idx) in filiais"
                :key="f.cnpj + idx"
                :value="f.cnpj"
              >
                {{ f.razao || f.nome_fantasia }}
              </option>
            </select>
          </div>
          <div class="mb-3 col-md-6 mx-auto">
            <label for="vendedor" class="form-label">Vendedor(a):</label>
            <select
              name="vendedor"
              id="vendedor"
              class="form-select"
              v-model="vendedor.val"
            >
              <set-vendedor
                v-for="vendedor in vendedores"
                :key="vendedor.codigo_vendedor"
                :nome="vendedor.nome"
                :codigo="vendedor.codigo_vendedor"
              ></set-vendedor>
            </select>
          </div>
          <div class="centralizador">
            <strong>Total do Pedido: </strong> R$ {{ carrinhoTotal }}
            <p v-if="!cartIsValid">
              Por favor, selecione um produto antes de confirmar a compra.
            </p>
          </div>
        </div>
      </div>
      <br />
      <h1 v-if="dadosCliente.endereco">
        Entrega
        <button @click="editarEndereco()" class="styleBtn">
          Alterar endereço
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            class="bi bi-pencil"
            viewBox="0 0 16 16"
          >
            <path
              d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
            />
          </svg>
        </button>
      </h1>

      <hr />
      <div class="enderecoStyle" v-if="dadosCliente.endereco">
        <p>
          {{ dadosCliente.endereco[0].cidade }} -
          {{ dadosCliente.endereco[0].uf }}
        </p>
        <p>
          {{ dadosCliente.endereco[0].logradouro }}, Nº
          {{ dadosCliente.endereco[0].numero }},
          {{ dadosCliente.endereco[0].bairro }}
        </p>
        <p>CEP: {{ dadosCliente.endereco[0].cep }}</p>
      </div>
      <div class="button-control">
        <br />
        <button @click="validateForm">Confirmar</button>
      </div>
    </div>
  </div>
  <div v-if="carregamentoPedidos" class="fullbody">
    <base-spinner></base-spinner><br />
  </div>

  <div v-if="pedidofinalizado && !carregamentoPedidos" class="fullbody">
    <div class="centralizador">
      <div class="container">
        <h1
          class="mt-3"
          v-if="
            statusPedido.status == 'Pedido cadastrado com sucesso.' ||
            statusPedido.status == 'Venda balcão cadastrado com sucesso.'
          "
        >
          Obrigado!
        </h1>
        <h1 class="mt-3" v-else>Ops.. algo deu errado!</h1>
        <hr />
        <h2>{{ statusPedido.status }}</h2>
        <h4>Código Pedido: {{ statusPedido.codigo_pedido }}</h4>
        <div class="centrali">
          <router-link :to="meusPedidosLink" v-slot="{ href, route, navigate }">
            <button :href="href" @click="navigate">
              Ver Pedidos {{ route.MeusPedidos }}
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <br />
  <AppFooter id="footer" />
</template>

<script>
import AppFooter from "@/components/AppFooter.vue";
import SetVendedor from "@/components/vendedor/SetVendedor.vue";
import { mapState } from "vuex";
import moment from "moment";

export default {
  props: ["tokenTipo", "tokenLoja"],
  components: {
    SetVendedor,
    AppFooter,
  },
  data() {
    return {
      cartIsValid: true,
      observacao: {
        val: "",
        isValid: true,
      },
      vendedor: {
        val: "",
        isValid: true,
      },
      filial: {
        val: "",
        isValid: true,
      },
      pedidofinalizado: false,
    };
  },
  methods: {
    async carregarRodape() {
      await this.$store.dispatch("empresa/carregarRodape");
      document.title = this.empresarodape.nome;
    },
    top() {
      window.scrollTo(0, 0);
    },
    async carregarMeusPedidos() {
      if (this.dadosCliente.cpf != "") {
        await this.$store.dispatch("login/carregarMeusPedidos", {
          cnpj: this.empresarodape.cnpj,
          senha: this.dadosCliente.senha,
          codigo: this.dadosCliente.cpf,
          dataInicio: moment().startOf("month").format("YYYY-MM-DD"),
          dataFim: moment().format("YYYY-MM-DD"),
        });
      } else {
        await this.$store.dispatch("login/carregarMeusPedidos", {
          cnpj: this.empresarodape.cnpj,
          senha: this.senha.val,
          codigo: this.dadosCliente.cnpj,
          dataInicio: moment().startOf("month").format("YYYY-MM-DD"),
          dataFim: moment().format("YYYY-MM-DD"),
        });
      }
    },
    async validateForm() {
      this.top();
      if (this.$store.getters["carrinhos/somaTotal"] <= 0) {
        this.cartIsValid = false;
      } else {
        // use selected filial CNPJ if provided, otherwise default to empresarodape.cnpj
        const selectedCnpj = this.filial.val || this.empresarodape.cnpj;

        await this.$store.dispatch("requests/realizarPedido", {
          codigoempresa: selectedCnpj,
          codigovendedor: this.vendedor.val,
          observacao: this.observacao.val,
        });

        this.carregarMeusPedidos();
        this.$store.dispatch("produtos/resetSelect");
        this.$store.dispatch("carrinhos/resetSelect");
        this.pedidofinalizado = true;
      }
    },
    async carregarCategorias() {
      await this.$store.dispatch("produtos/carregarCategorias");
    },
    async carregarVendedores() {
      this.isLoading = true;
      await this.$store.dispatch("empresa/carregarVendedores", {
        codigoempresa: this.empresarodape.cnpj,
      });
      this.isLoading = false;
    },
    async carregarFiliais() {
      await this.$store.dispatch("empresa/carregarFiliais");
    },
    editarEndereco() {
      this.$router.push(this.cadastroLink);
    },
  },
  computed: {
    ...mapState("empresa", ["empresarodape"]),
    ...mapState("empresa", ["vendedores", "filiais"]),
    ...mapState("login", ["dadosCliente"]),
    ...mapState("requests", ["carregamentoPedidos"]),

    statusPedido() {
      return this.$store.getters["requests/statusPedido"];
    },
    cadastroLink() {
      return "/" + this.tipo + "/" + this.loja + "/cadastro";
    },
    resumoCompras() {
      return this.$store.getters["carrinhos/produtos"];
    },
    statusCompra() {
      return this.$store.getters["requests/statusCompra"];
    },
    loja() {
      return this.$store.getters["loja/lojaSelecionada"];
    },
    tipo() {
      return this.$store.getters["loja/tipoSelecionado"];
    },
    meusPedidosLink() {
      return "/" + this.tipo + "/" + this.loja + "/produtos/meuspedidos";
    },
    carrinhoTotal() {
      return this.$store.getters["carrinhos/somaTotal"].toLocaleString(
        "pt-br",
        { minimumFractionDigits: 2 }
      );
    },
    itemTotal() {
      return (this.resumoCompra.preco * this.item.qtd).toLocaleString("pt-br", {
        minimumFractionDigits: 2,
      });
    },
  },
  created() {
    this.carregarRodape();
    this.carregarCategorias();
    this.carregarVendedores();
    this.carregarFiliais();
  },
  watch: {
    "filial.val": function (newVal) {
      // when filial changes, reload vendedores for that CNPJ
      const cnpj = newVal || this.empresarodape.cnpj;
      this.$store.dispatch("empresa/carregarVendedores", {
        codigoempresa: cnpj,
      });
    },
  },
};
</script>

<style scoped>
@import "@/styles/variables.css";

h1 {
  color: var(--primary-color);
  margin: 0px 40px;
}

h4 {
  text-align: center;
  font-weight: lighter;
}

.resumo-compra {
  text-align: left;
  font-size: 25px;
  margin: 30px auto;
  max-width: 80rem;
}

h3 {
  font-size: calc(1rem + 0.9vw);
  font-weight: 500;
  line-height: 1.2;
  margin: 40px 0px;
  color: #292929;
  text-align: left;
  border-bottom: 2px solid #ccc;
  padding-bottom: 1rem;
}

.fullbody {
  min-height: 100vh;
}

#resumoItem {
  border: 1px solid rgba(0, 0, 0, 0.322);
  border-radius: 20px;
  max-width: 55rem;
  text-align: center;
  margin: auto;
  align-items: center;
  font-size: 15px;
  padding: 20px;
}

#observation {
  font-weight: 500;
  margin: 0px 10px;
  padding: 1rem 0.75rem;
}

.form-floating {
  border-radius: 20px;
  max-width: 40rem;
  margin: 20px auto;
  font-size: 15px;
}

.centralizador {
  text-align: center;
}

.enderecoStyle {
  margin-left: 30px;
}

ul {
  list-style: none;
  text-align: left;
}

li {
  text-align: left;
}

.button-control {
  margin: auto;
  max-width: 50rem;
  text-align: center;
}

button {
  font: inherit;
  cursor: pointer;
  background-color: var(--primary-color);
  color: white;
  border: 1px solid var(--primary-color);
  margin: 10px;
  padding: 0.5rem 1.5rem;
  border-radius: 30px;
}

.styleBtn {
  font-weight: normal;
  font-size: 25px;
}

.edit {
  background-color: red;
  border: 1px solid red;
}

.edit:hover {
  background-color: red;
  border: 1px solid red;
}

button:hover,
button:active {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}
</style>
